import actionTypes from "../../common/actionTypes";
import { DATABASE_STATUTES } from "../../common/constants";

export const reportsReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PREORDER_REVENUE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadPreorderRevenue: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          preorderRevenue: null,
        },
      };

    case actionTypes.FETCH_PREORDER_REVENUE_SUCCESS:
      return {
        ...state,
        preorderRevenue: action.payload.data,
        dateRange: action.payload.dateRange,
        statuses: {
          ...state.statuses,
          loadPreorderRevenue: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          preorderRevenue: null,
        },
      };

    case actionTypes.FETCH_PREORDER_REVENUE_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadPreorderRevenue: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          preorderRevenue: action.error,
        },
      };

    case actionTypes.FETCH_TOP_PREORDER_PRODUCTS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadTopPreorderProducts: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          topPreorderProducts: null,
        },
      };

    case actionTypes.FETCH_TOP_PREORDER_PRODUCTS_SUCCESS:
      return {
        ...state,
        topPreorderProducts: action.payload.data,
        dateRange: action.payload.dateRange,
        statuses: {
          ...state.statuses,
          loadTopPreorderProducts: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          topPreorderProducts: null,
        },
      };

    case actionTypes.FETCH_TOP_PREORDER_PRODUCTS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadTopPreorderProducts: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          topPreorderProducts: action.error,
        },
      };

    case actionTypes.FETCH_PREORDER_NOTIFICATIONS_TRENDS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadPreorderNotificationsTrends: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          preorderNotificationsTrends: null,
        },
      };

    case actionTypes.FETCH_PREORDER_NOTIFICATIONS_TRENDS_SUCCESS:
      return {
        ...state,
        preorderNotificationsTrends: action.payload.data,
        dateRange: action.payload.dateRange,
        statuses: {
          ...state.statuses,
          loadPreorderNotificationsTrends: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          preorderNotificationsTrends: null,
        },
      };

    case actionTypes.FETCH_PREORDER_NOTIFICATIONS_TRENDS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadPreorderNotificationsTrends: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          preorderNotificationsTrends: action.error,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_TRENDS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadBackInStockTrends: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          backInStockTrends: null,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_TRENDS_SUCCESS:
      return {
        ...state,
        backInStockTrends: action.payload.data,
        dateRange: action.payload.dateRange,
        statuses: {
          ...state.statuses,
          loadBackInStockTrends: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          backInStockTrends: null,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_TRENDS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadBackInStockTrends: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          backInStockTrends: action.error,
        },
      };

    case actionTypes.FETCH_TOP_BACK_IN_STOCK_PRODUCTS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadTopBackInStockProducts: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          topBackInStockProducts: null,
        },
      };

    case actionTypes.FETCH_TOP_BACK_IN_STOCK_PRODUCTS_SUCCESS:
      return {
        ...state,
        topBackInStockProducts: action.payload.data,
        dateRange: action.payload.dateRange,
        statuses: {
          ...state.statuses,
          loadTopBackInStockProducts: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          topBackInStockProducts: null,
        },
      };

    case actionTypes.FETCH_TOP_BACK_IN_STOCK_PRODUCTS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadTopBackInStockProducts: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          topBackInStockProducts: action.error,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_CONVERSIONS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadBackInStockConversions: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          backInStockConversions: null,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_CONVERSIONS_SUCCESS:
      return {
        ...state,
        backInStockConversions: action.payload.data,
        dateRange: action.payload.dateRange,
        statuses: {
          ...state.statuses,
          loadBackInStockConversions: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          backInStockConversions: null,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_CONVERSIONS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadBackInStockConversions: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          backInStockConversions: action.error,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_NOTIFICATIONS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadBackInStockNotifications: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          backInStockNotifications: null,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        backInStockNotifications: {
          ...state.backInStockNotifications,
          items: action.payload.items,
          pagination: action.payload.pagination,
        },
        statuses: {
          ...state.statuses,
          loadBackInStockNotifications: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          backInStockNotifications: null,
        },
      };

    case actionTypes.FETCH_BACK_IN_STOCK_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadBackInStockNotifications: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          backInStockNotifications: action.error,
        },
      };

    case actionTypes.DELETE_BACK_IN_STOCK_NOTIFICATION:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          deleteBackInStockNotification: DATABASE_STATUTES.IN_PROGRESS,
        },
        errors: {
          ...state.errors,
          deleteBackInStockNotification: null,
        },
      };

    case actionTypes.DELETE_BACK_IN_STOCK_NOTIFICATION_SUCCESS: {
      const updatedSelectedIds = new Set(state.backInStockNotifications.selectedIds);
      updatedSelectedIds.delete(action.payload.id);
      return {
        ...state,
        backInStockNotifications: {
          ...state.backInStockNotifications,
          items: state.backInStockNotifications.items.filter((item) => item.id !== action.payload.id),
          selectedIds: updatedSelectedIds,
        },
        statuses: {
          ...state.statuses,
          deleteBackInStockNotification: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          deleteBackInStockNotification: null,
        },
      };
    }

    case actionTypes.DELETE_BACK_IN_STOCK_NOTIFICATION_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          deleteBackInStockNotification: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          deleteBackInStockNotification: action.error,
        },
      };

    case actionTypes.UPDATE_REPORTS_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };

    case actionTypes.SET_BACK_IN_STOCK_SELECTIONS:
      return {
        ...state,
        backInStockNotifications: {
          ...state.backInStockNotifications,
          selectedIds: new Set(Array.isArray(action.payload) ? action.payload : [action.payload]),
        },
      };

    case actionTypes.CLEAR_BACK_IN_STOCK_SELECTIONS:
      return {
        ...state,
        backInStockNotifications: {
          ...state.backInStockNotifications,
          selectedIds: new Set(),
        },
      };

    case actionTypes.FETCH_EMAIL_LOGS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadEmailLogs: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          emailLogs: null,
        },
      };

    case actionTypes.FETCH_EMAIL_LOGS_SUCCESS:
      return {
        ...state,
        emailLogs: {
          ...state.emailLogs,
          items: action.payload.items,
          pagination: action.payload.pagination,
        },
        statuses: {
          ...state.statuses,
          loadEmailLogs: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          emailLogs: null,
        },
      };

    case actionTypes.FETCH_EMAIL_LOGS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadEmailLogs: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          emailLogs: action.error,
        },
      };

    case actionTypes.FETCH_ORDERS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADING,
        },
        errors: {
          ...state.errors,
          orders: null,
        },
      };

    case actionTypes.FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          items: action.payload.items,
          pagination: action.payload.pagination,
        },
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          orders: null,
        },
      };

    case actionTypes.FETCH_ORDERS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          orders: action.error,
        },
      };

    case actionTypes.SET_ORDERS_SELECTIONS:
      return {
        ...state,
        orders: {
          ...state.orders,
          selectedIds: new Set(Array.isArray(action.payload) ? action.payload : [action.payload]),
        },
      };

    case actionTypes.CLEAR_ORDERS_SELECTIONS:
      return {
        ...state,
        orders: {
          ...state.orders,
          selectedIds: new Set(),
        },
      };

    case actionTypes.SEND_SHIPPING_DELAY_EMAILS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          sendShippingDelayEmails: DATABASE_STATUTES.IN_PROGRESS,
        },
        errors: {
          ...state.errors,
          sendShippingDelayEmails: null,
        },
      };

    case actionTypes.SEND_SHIPPING_DELAY_EMAILS_SUCCESS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          sendShippingDelayEmails: DATABASE_STATUTES.LOADED,
        },
        errors: {
          ...state.errors,
          sendShippingDelayEmails: null,
        },
      };

    case actionTypes.SEND_SHIPPING_DELAY_EMAILS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          sendShippingDelayEmails: DATABASE_STATUTES.LOADED_ERROR,
        },
        errors: {
          ...state.errors,
          sendShippingDelayEmails: action.error,
        },
      };

    default:
      return state;
  }
};
